import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  fetchFeedbackCSDeleteRequest,
  fetchFeedbackCSRequest,
  resetFeedbackCS,
  resetFeedbackCSDelete,
} from "../../views/case-summary-one-view/store/actions";
import { GROUP_REF_SELETECTED, TOKEN, getData } from "../../utils/Storage";
import AddFeedbackPopup from "./AddFeedbackPopup";
import KendoGrid from "../../views/case-summary-one-view/components/kendo-grid-feedback";
import { GridLoader } from "../../views/case-summary-one-view/components";
import { closeIcon } from "../../assets/icons";
import { useTranslation } from "react-i18next";

// Functional component for Information Governance
const FeedbackPopup = (props: any) => {
  const { t } = useTranslation();
  // State for storing the "involve case" data
  const dispatch = useDispatch();
  const [showPopup, setShowPopup] = useState(false);
  const [localToken, setLocalToken] = useState<any>({
    isLegacy: false,
    token: "",
  });
  const [sectionNamelist, setSectionNameList] = useState([]);
  const feedbackCslistdata: any = useSelector<any>((state) => state.feedbackCs);

  const feedbackCslistDataDelete: any = useSelector<any>(
    (state) => state.feedbackCsDelete
  );
  const [feedbackList, setFeedbackList] = useState<any>(null);

  const selectedDSP = props.dspId;
  const caseSummaryType = props.summaryTypeID;
  const selectedCaseReference = props.oneViewReference;

  useEffect(() => {
    setLocalToken(props.token);
    feedbackCsApiCall(props.token);
  }, []);

  const feedbackCsApiCall = (token: any) => {
    if (selectedCaseReference !== null) {
      let body = {
        token: token,
        caseSummaryType: caseSummaryType,
        dspId: selectedDSP,
        oneViewReference: selectedCaseReference,
      };
      dispatch(fetchFeedbackCSRequest({ token: token, params: body }));
    }
  };

  useEffect(() => {
    if (feedbackCslistdata.isSuccess && feedbackCslistdata.data !== null) {
      setFeedbackList(feedbackCslistdata.data);

      let list = feedbackCslistdata.data.gridColumns.filter((item: any) => {
        if (item.dataType === "picklist") return item.pickListValues;
      });
      let newData = list[0].pickListValues.map((item: any) =>
        item ? { text: item.textToDisplay, value: item.valueToStore } : item
      );
      setSectionNameList(newData);

      dispatch(resetFeedbackCS());
    } else if (feedbackCslistdata.isError) {
      toast.error(
        feedbackCslistdata.data.error.data ||
          feedbackCslistdata.data.error.status
      );
      dispatch(resetFeedbackCS());
    }
  }, [feedbackCslistdata]);

  useEffect(() => {
    if (
      feedbackCslistDataDelete.isSuccess &&
      feedbackCslistDataDelete.data !== null
    ) {
      toast.success("Record deleted successfully");
      dispatch(resetFeedbackCSDelete());
      feedbackCsApiCall(localToken);
    } else if (feedbackCslistDataDelete.isError) {
      toast.error(feedbackCslistDataDelete.data.error.data.title);
      dispatch(resetFeedbackCSDelete());
    }
  }, [feedbackCslistDataDelete]);

  const __onCustomAction = (e: any) => {
    try {
      if (e.action === "delete") {
        dispatch(
          fetchFeedbackCSDeleteRequest({
            token: localToken,
            params: {
              feedbackId: e.dataItem.FeedbackId,
              oneViewReference: selectedCaseReference,
            },
          })
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  const renderGridfeedback = (data: any) => {
    return (
      <div className="p-3" style={{}}>
        <KendoGrid
          dspId={selectedDSP}
          caseSummaryType={caseSummaryType}
          oneViewReference={selectedCaseReference}
          sectionPickList={sectionNamelist}
          caseData={data}
          token={localToken}
          customAction={(res: any) => {
            __onCustomAction(res);
          }}
          pageSize={data.length}
        />
      </div>
    );
  };
  const addpop = () => {
    return (
      <AddFeedbackPopup
        token={localToken}
        feedbackId={""}
        dspId={selectedDSP}
        caseSummaryType={caseSummaryType}
        isFrom="add"
        sectionId={props.sectionId}
        notes={""}
        sectionList={sectionNamelist}
        oneViewReference={selectedCaseReference}
        title={"Add Feedback"}
        onCancel={(res: any) => {
          setShowPopup(false);
        }}
        onAddSuccess={(res: any) => {
          dispatch(
            fetchFeedbackCSRequest({
              token: localToken,
              params: {
                token: localToken,
                dspId: selectedDSP,
                caseSummaryType: caseSummaryType,
                oneViewReference: selectedCaseReference,
              },
            })
          );
        }}
      />
    );
  };

  const renderHeader = () => {
    return (
      <div className="modal-header">
        <h5
          className={
            "aside-top-bar " +
            (props.title !== "" ? "justify-content-sm-between" : "")
          }
          id="exampleModalLabel"
        >
          {props.title}
        </h5>
        <button
          style={{ marginRight: 2 }}
          className="btn-header-feedback btn feedback-button "
          onClick={() => setShowPopup(true)}
        >
          Add Feedback
        </button>
        <button
          style={{
            marginRight: 12,
            backgroundColor: "#5464B0",
            borderColor: "#5464B0",
            borderWidth: 1,
          }}
          className="btn btn-transparent"
          onClick={props.onClose}
        >
          <img src={closeIcon} alt="Close icon" />
        </button>
      </div>
    );
  };

  const renderBody = () => {
    return (
      <div className="modal-body">
        {feedbackList !== null && feedbackList !== undefined ? (
          renderGridfeedback(feedbackList)
        ) : (
          <div>
            <GridLoader />
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="add-feedback">
      <div
        className="modal fade show"
        id="exampleModal"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        {showPopup ? (
          addpop()
        ) : (
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              {renderHeader()}
              {renderBody()}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FeedbackPopup;
